import axios from 'axios';

export default class ShopifyCollectionProvider {
  static getCollection(handle) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/collections/${handle}.json`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static getProductsPerPage(handle, pageNum, limit = 250) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/collections/${handle}/products.json?limit=${limit}&page=${pageNum}`
        )
        .then(response => {
          resolve(response.data.products);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static getAllPromisedProducts(handle) {
    return new Promise((resolve, reject) => {
      let allProducts = [];

      this.getCollection(handle)
        .then(result => {
          const totalPages = Math.ceil(
            result.data.collection.products_count / 250
          );

          for (let i = 1; i <= totalPages; i++) {
            allProducts.push(this.getProductsPerPage(handle, i));
          }

          Promise.all(allProducts)
            .then(promises => {
              allProducts = [];

              promises.forEach(promise => {
                allProducts = allProducts.concat(promise);
              });

              resolve(allProducts);
            })
            .catch(error => {
              reject(error);
            });
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static getCollectionProducts(handle) {
    return new Promise((resolve, reject) => {
      this.getAllPromisedProducts(handle)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
